var slider = new KeenSlider("#blog-banner__slider", {
}, 
[
  navigation,
  (slider) => {
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
      clearTimeout(timeout)
    }
    function nextTimeout() {
      clearTimeout(timeout)
      if (mouseOver) return
      timeout = setTimeout(() => {
        slider.next()
      }, 5000)
    }
    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true
        clearNextTimeout()
      })
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false
        nextTimeout()
      })
      nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
  },
])
var thumbnails = new KeenSlider(
  "#blog-banner__content-slider",
  {
    drag: false,
    defaultAnimation: {
      duration: 500,
    },
    detailsChanged: (s) => {
      s.slides.forEach((element, idx) => {
        element.style.opacity = s.track.details.slides[idx].portion
      })
    },
    renderMode: "custom",
  },
  [ThumbnailPlugin(this.slider)]
)


// Lazyload fix
document.addEventListener('lazybeforesizes', function(e) {
  if (e.target.classList.contains('blog-banner-image')) {
    e.detail.width = parseInt(getComputedStyle(e.target.closest('.blog-banner__image')).width) || e.detail.width;
  }
})